export class TrackingError implements Error {
  public readonly name = 'TrackingError'
  public readonly message: string = 'Error on tracking data to DataLayer'
  public readonly stack?: string

  constructor(public readonly error: unknown) {
    if (error instanceof Error) {
      this.message = error.message
      this.stack = error.stack
    }
    console.warn(`${this.name}: ${this.message}
      ${this.stack}`)
  }
}
